var __merlinGlobal = (typeof window !== 'undefined' ? window : globalThis);
var __merlinTrustedTypes = __merlinGlobal.MerlinTrustedTypes || (__merlinGlobal.MerlinTrustedTypes = (function() {
    function safeSetInnerHTML(element, html) {
        if (!element) return;
        if (!html) {
            element.replaceChildren();
            return;
        }

        var doc = new DOMParser().parseFromString('<body>' + html + '</body>', 'text/html');
        element.replaceChildren();
        Array.from(doc.body.childNodes).forEach(function(node) {
            element.appendChild(document.adoptNode(node));
        });
    }

    function safeInsertAdjacentHTML(element, position, html) {
        if (!element || !html) return;

        var doc = new DOMParser().parseFromString('<body>' + html + '</body>', 'text/html');
        var fragment = document.createDocumentFragment();
        Array.from(doc.body.childNodes).forEach(function(node) {
            fragment.appendChild(document.adoptNode(node));
        });

        switch (position) {
            case 'beforeend':
                element.appendChild(fragment);
                break;
            case 'afterbegin':
                element.prepend(fragment);
                break;
            case 'beforebegin':
                element.before(fragment);
                break;
            case 'afterend':
                element.after(fragment);
                break;
        }
    }

    return {
        safeSetInnerHTML: safeSetInnerHTML,
        safeInsertAdjacentHTML: safeInsertAdjacentHTML
    };
})());
var safeSetInnerHTML = __merlinTrustedTypes.safeSetInnerHTML;
var safeInsertAdjacentHTML = __merlinTrustedTypes.safeInsertAdjacentHTML;
/**
 * Graph Explorer - Hover Menu Module
 * Shows radial action menu when hovering over nodes for 2+ seconds
 */

(function(global) {
    'use strict';

    let hoverTimer = null;
    let menuElement = null;
    let currentNodeId = null;
    let isMenuVisible = false;
    let interactionsDeferred = false;
    const HOVER_DELAY = 1000; // 1 second

    // ============================================
    // Initialization
    // ============================================
    function init() {
        createMenuElement();
        bindEvents();
        console.log('[ExplorerHoverMenu] Initialized');
    }

    function createMenuElement() {
        if (document.getElementById('node-hover-menu')) {
            menuElement = document.getElementById('node-hover-menu');
            return;
        }

        menuElement = document.createElement('div');
        menuElement.id = 'node-hover-menu';
        menuElement.className = 'node-hover-menu';
        safeSetInnerHTML(menuElement, `
            <button class="node-hover-menu-btn extend" data-action="extend" data-tooltip="Extend">
                🔎
            </button>
            <button class="node-hover-menu-btn connect" data-action="connect" data-tooltip="Connect">
                ⤨
            </button>
            <button class="node-hover-menu-btn intersect" data-action="intersect" data-tooltip="Intersect">
                ∩
            </button>
            <button class="node-hover-menu-btn differs" data-action="differs" data-tooltip="Differs">
                ≠
            </button>
            <button class="node-hover-menu-btn union" data-action="union" data-tooltip="Union">
                ∪
            </button>
            <button class="node-hover-menu-btn isolate" data-action="isolate" data-tooltip="Isolate">
                ✂
            </button>
            <button class="node-hover-menu-btn remove" data-action="remove" data-tooltip="Remove">
                ✕
            </button>
        `);
        
        const container = document.querySelector('.graph-explorer');
        if (container) {
            container.appendChild(menuElement);
        }
    }

    // ============================================
    // Event Binding
    // ============================================
    function bindEvents() {
        // Menu button clicks
        menuElement?.addEventListener('click', function(e) {
            const btn = e.target.closest('.node-hover-menu-btn');
            if (btn) {
                const action = btn.dataset.action;
                executeAction(action);
                hideMenu();
            }
        });

        // Keep menu visible when hovering over it
        menuElement?.addEventListener('mouseenter', function() {
            clearTimeout(hoverTimer);
        });

        // Hide menu when leaving it (with small delay)
        menuElement?.addEventListener('mouseleave', function() {
            hoverTimer = setTimeout(function() {
                hideMenu();
            }, 500);
        });
    }

    // ============================================
    // Menu Display
    // ============================================
    function showMenu(nodeId, canvasPosition) {
        if (!menuElement || interactionsDeferred) return;

        currentNodeId = nodeId;
        
        // Position menu at node location
        menuElement.style.left = canvasPosition.x + 'px';
        menuElement.style.top = canvasPosition.y + 'px';
        
        // Show with animation
        requestAnimationFrame(function() {
            menuElement.classList.add('visible');
        });
        
        isMenuVisible = true;
    }

    function hideMenu() {
        if (!menuElement) return;
        
        menuElement.classList.remove('visible');
        isMenuVisible = false;
        currentNodeId = null;
        clearTimeout(hoverTimer);
    }

    function isVisible() {
        return isMenuVisible;
    }

    // ============================================
    // Hover Detection (called from network events)
    // ============================================
    function startHoverTimer(nodeId, canvasPosition) {
        if (interactionsDeferred) {
            return;
        }
        clearTimeout(hoverTimer);
        
        hoverTimer = setTimeout(function() {
            showMenu(nodeId, canvasPosition);
        }, HOVER_DELAY);
    }

    function cancelHoverTimer() {
        clearTimeout(hoverTimer);
        // Don't hide immediately - let the menu be usable
        if (isMenuVisible) {
            hoverTimer = setTimeout(function() {
                hideMenu();
            }, 300);
        }
    }

    function setInteractionsDeferred(deferred) {
        interactionsDeferred = !!deferred;
        if (interactionsDeferred) {
            hideMenu();
        }
    }

    function areInteractionsDeferred() {
        return interactionsDeferred;
    }

    // ============================================
    // Action Execution - Opens Modal
    // ============================================
    function executeAction(action) {
        // Select the hovered node if not already selected
        if (currentNodeId) {
            const selectedNodes = GraphExplorer.getState().selectedNodes || [];
            if (!selectedNodes.includes(currentNodeId)) {
                const nodeData = GraphExplorer.getState().nodes?.get(currentNodeId);
                GraphExplorer.selectNode(currentNodeId, nodeData);
            }
        }

        // Open the action modal
        ExplorerModal.open(action);
    }

    // ============================================
    // Public API
    // ============================================
    global.ExplorerHoverMenu = {
        init,
        showMenu,
        hideMenu,
        isVisible,
        startHoverTimer,
        cancelHoverTimer,
        setInteractionsDeferred,
        areInteractionsDeferred
    };

})(window);
